export const UUID_REGEX =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-5][0-9a-f]{3}-[089ab][0-9a-f]{3}-[0-9a-f]{12}$/i

export const START_SIMULATION_BUTTON_LABEL = 'Fazer cotação'

export const BROKERS_BUTTON_LABEL = 'Para corretores'
